export const CHANGE_LOCALE = 'change-locale';
const changeLocale = ({ locale }) => ({
  type: CHANGE_LOCALE,
  payload: { locale },
});
export default changeLocale;
